/*
 * Copyright (c) 2022. Nedaware SL
 */

import {Injectable} from '@angular/core';
import {MatSnackBar} from "@angular/material/snack-bar";
import {ErrorToStringService} from "../../api/error-to-string.service";

@Injectable({
    providedIn: 'root'
})
export class ErrorDisplayService {
    constructor(private _matSnack: MatSnackBar, private _errorTranslator: ErrorToStringService) {
    }

    public displayError(error: any, duration: number = null) {
        const string = this._errorTranslator.errorToString(error);
        this.displayRaw(string, duration);
    }

    public displayRaw(error: string, duration: number = 5000, clases?: string[]) {
        this._matSnack.open(error, 'Ok', {duration: duration, panelClass: clases});
    }
}
